import { render, staticRenderFns } from "./UnitsInput.vue?vue&type=template&id=16e677d2&scoped=true&"
import script from "./UnitsInput.vue?vue&type=script&lang=js&"
export * from "./UnitsInput.vue?vue&type=script&lang=js&"
import style0 from "./UnitsInput.vue?vue&type=style&index=0&id=16e677d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e677d2",
  null
  
)

export default component.exports